// extracted by mini-css-extract-plugin
export default {"popoverButton":"viewMatchPopover_popoverButton__bKoyM"};